import { useUserDataState } from "src/user-data/useUserDataState.ts";
import type { ModuleTabsPersistedState } from "src/user-data/types.ts";
import { ModuleLayoutTabsUserDataSchema } from "src/user-data/schemas.ts";
import { sanitazeModuleLayoutTabs } from "src/user-data/sanitazors.ts";
import { useDataRouterContext } from "src/lib/react-router/useDataRouterContext.ts";
import { useUser } from "src/auth/auth.ts";
import { useCallback } from "react";
import type { StorageKey } from "@exonn/storage";

export const useSetTabTitle = ({ storageKey }: { storageKey: StorageKey }) => {
  const { data: user } = useUser();
  const { router } = useDataRouterContext();

  const { getValue: getUserDataState, setValue: setUserDataState } =
    useUserDataState<ModuleTabsPersistedState>({
      key: storageKey,
      validationSchema: ModuleLayoutTabsUserDataSchema,
      sanitaze: sanitazeModuleLayoutTabs(router),
      user: user!,
    });
  return useCallback(
    ({ id, title }: { id: string; title: string }) => {
      const userDataState = getUserDataState();
      if (userDataState) {
        const prevTitle = userDataState?.titles?.[id];
        if (prevTitle === title) {
          return;
        }

        const newUserData = {
          ...userDataState,
          titles: {
            ...userDataState.titles,
            [id]: title,
          },
        };
        setUserDataState(newUserData);
      }
    },
    [setUserDataState, getUserDataState],
  );
};
